const { ALGOLIA_APPLICATION_ID, ALGOLIA_ENV, ALGOLIA_SEARCH_API, APP_ENV } = process.env

export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
const algoliaEnv: string = ALGOLIA_ENV || APP_ENV || 'production'
export const searchIndice: string = `${algoliaEnv}_all_artworks_artist_order`
export const DEFAULT_APP = '/user/artworks'

// Will add additional sort options in part 2.
export const sortOptions: Array<{
  value: string
  title: string
  indice: string
}> = [
  {
    value: 'default',
    title: 'Default',
    indice: searchIndice,
  },
]

export const USER_ARTWORKS_NEXT_APP_ROUTE = '/user/artworks'
